import React from "react";
import LoadingPage from './LoadingPage';

import "../styles/general.scss";
import LandingPage from "./LandingPage";
import GamePage from "./GamePage";
import MusicButton from "../components/MusicButton";
import {debugPrint, getBase64Image, getMedian} from "../utilities/Utilities";

import Title from "../images/background/title.png";
import BikeGirl from "../images/spritesheet/bike_girl_1x.png";
import BikeGirlRest from "../images/spritesheet/bike_girl_rest_1x.png";
import DarkBG from "../images/background/dark_bg.png";
import GamePageForwardButtonReleased from "../images/buttons/forward_button_released_1x.png";
import GamePageForwardButtonPressed from "../images/buttons/forward_button_pressed_1x.png";
import GamePageBackwardButtonReleased from "../images/buttons/backward_button_released_1x.png";
import GamePageBackwardButtonPressed from "../images/buttons/backward_button_pressed_1x.png";
import GamePageLightBulbButton from "../images/buttons/lightbulb_1x.png";
import LandingPageButton from "../images/buttons/landing_page_button.png";
import EnterPosterPageButton from "../images/buttons/enter_poster_page_button.png";
import GamePageMG from "../images/background/game_mg_2x.png";
import GamePageMGFull from "../images/background/game_mg_full_2x.jpg";
// import GamePageMGBlur from "../images/background/game_mg_full_blur_2x.png";
import GamePageBG from "../images/background/game_bg_1x.png";
import GamePageBGCloud from "../images/background/game_bg_cloud_1x.png";
import GamePageFG from "../images/background/game_fg_2x.png";
import GamePageFGFull from "../images/background/game_fg_full_2x.png";
// import GamePageFGBlur from "../images/background/game_fg_full_blur_2x.png";
import GamePageBGLocationDescriptionA from "../images/background/game_bg_location_description_a_2x.png";
import GamePageBGLocationDescriptionB from "../images/background/game_bg_location_description_b_2x.png";
import GamePageBGLocationDescriptionC from "../images/background/game_bg_location_description_c_2x.png";
import GamePageBGLocationDescriptionD from "../images/background/game_bg_location_description_d_2x.png";
import GamePageBGLocationDescriptionE from "../images/background/game_bg_location_description_e_2x.png";
import GamePageMGFloatA from "../images/background/game_mg_float_a_2x.png";
import GamePageMGFloatB from "../images/background/game_mg_float_b_2x.png";
import GamePageMGFloatC from "../images/background/game_mg_float_c_2x.png";
import GamePageMGFloatD from "../images/background/game_mg_float_d_2x.png";
import GamePageMGFloatE from "../images/background/game_mg_float_e_2x.png";
import GamePageMGFloatF from "../images/background/game_mg_float_f_2x.png";
import GamePageMGFloatG from "../images/background/game_mg_float_g_2x.png";
import GamePageMGFloatH from "../images/background/game_mg_float_h_2x.png";
import GamePageMGFloatI from "../images/background/game_mg_float_i_2x.png";
import GamePageMGFloatJ from "../images/background/game_mg_float_j_2x.png";
import GamePageMGFloatK from "../images/background/game_mg_float_k_2x.png";
import GamePageMGFloatL from "../images/background/game_mg_float_l_2x.png";
import LandingPageBG from "../images/background/landing_page_bg.png";
import LandingPageContent from "../images/contents/landing_page_content.png";
import EnterPosterPageContent from "../images/contents/enter_poster_page_content.png";
import MusicToggleOnButton from "../images/icons/music_toggle_on.png";
import MusicToggleOffButton from "../images/icons/music_toggle_off.png";
import PortraitModeAlert from "../images/background/portrait_mode_alert_bg.png";
import GameplayTipsContent from "../images/contents/gameplay_tips_content.png";
import StartGameButton from "../images/buttons/start_game_button.png";
import PopUpLeftButton from "../images/pop_up/pop_up_left_button.png";
import PopUpRightButton from "../images/pop_up/pop_up_right_button.png";
import PopUpCloseButton from "../images/pop_up/pop_up_close_button.png";
import PreviousPosterButton from "../images/buttons/previous_poster_button.png";
import NextPosterButton from "../images/buttons/next_poster_button.png";
import PostBeforeContent from "../images/contents/post_before_content.png";
import PostAfterContent from "../images/contents/poster_after_content.png";
import PostAfterTipsContent from "../images/contents/poster_tips_content.png";
import EnterVoucherPageButton from "../images/buttons/retrieve_voucher_button.png";
import EnterShopPageButton from "../images/buttons/enter_shop_button.png";
import EnterNextPosterPageButton from "../images/buttons/next_next_poster_page_button.png";
import PosterPageA from "../images/posters/poster_a.png";
import PosterPageB from "../images/posters/poster_b.png";
import PosterPageC from "../images/posters/poster_c.png";
import PosterPageD from "../images/posters/poster_d.png";
import PosterPageE from "../images/posters/poster_e.png";
import PosterPageF from "../images/posters/poster_f.png";
import PosterPageSaveA from "../images/posters/poster_save_a.jpg";
import PosterPageSaveB from "../images/posters/poster_save_b.jpg";
import PosterPageSaveC from "../images/posters/poster_save_c.jpg";
import PosterPageSaveD from "../images/posters/poster_save_d.jpg";
import PosterPageSaveE from "../images/posters/poster_save_e.jpg";
import PosterPageSaveF from "../images/posters/poster_save_f.jpg";
import Product111 from "../images/products/products_111.jpg";
import Product112 from "../images/products/products_112.jpg";
import Product121 from "../images/products/products_121.jpg";
import Product122 from "../images/products/products_122.jpg";
import Product211 from "../images/products/products_211.jpg";
import Product212 from "../images/products/products_212.jpg";
import Product213 from "../images/products/products_213.jpg";
import Product214 from "../images/products/products_214.jpg";
import Product221 from "../images/products/products_221.jpg";
import Product222 from "../images/products/products_222.jpg";
import Product223 from "../images/products/products_223.jpg";
import Product311 from "../images/products/products_311.jpg";
import Product312 from "../images/products/products_312.jpg";
import Product313 from "../images/products/products_313.jpg";
import Product314 from "../images/products/products_314.jpg";
import Product321 from "../images/products/products_321.jpg";
import Product411 from "../images/products/products_411.jpg";
import Product412 from "../images/products/products_412.jpg";
import Product413 from "../images/products/products_413.jpg";
import Product414 from "../images/products/products_414.jpg";
import Product421 from "../images/products/products_421.jpg";
import Product422 from "../images/products/products_422.jpg";
import Product423 from "../images/products/products_423.jpg";
import Product424 from "../images/products/products_424.jpg";
import Product511 from "../images/products/products_511.jpg";
import Product512 from "../images/products/products_512.jpg";
import Product521 from "../images/products/products_521.jpg";
import Product522 from "../images/products/products_522.jpg";
import Product523 from "../images/products/products_523.jpg";
import Product524 from "../images/products/products_524.jpg";
import Product531 from "../images/products/products_531.jpg";
import Product532 from "../images/products/products_532.jpg";
import Product541 from "../images/products/products_541.jpg";
import Product551 from "../images/products/products_551.jpg";
import Product561 from "../images/products/products_561.jpg";
import Product562 from "../images/products/products_562.jpg";
import Product571 from "../images/products/products_571.jpg";
import Product572 from "../images/products/products_572.jpg";
import Product573 from "../images/products/products_573.jpg";
import Product574 from "../images/products/products_574.jpg";
import Product581 from "../images/products/products_581.jpg";
import Product582 from "../images/products/products_582.jpg";
import Product591 from "../images/products/products_591.jpg";
import Product592 from "../images/products/products_592.jpg";
import BGM from "../music/background_music.mp3";
import {UIColors} from "../config/UIConfig";
import PosterPage from "./PosterPage";
import queryString from 'query-string';

const resourceToLoad = [
    Title,
    DarkBG,
    BikeGirl,
    BikeGirlRest,
    GamePageLightBulbButton,
    GamePageBGLocationDescriptionA,
    GamePageBGLocationDescriptionB,
    GamePageBGLocationDescriptionC,
    GamePageBGLocationDescriptionD,
    GamePageBGLocationDescriptionE,
    GamePageForwardButtonReleased,
    GamePageForwardButtonPressed,
    GamePageBackwardButtonReleased,
    GamePageBackwardButtonPressed,
    LandingPageBG,
    LandingPageButton,
    MusicToggleOnButton,
    MusicToggleOffButton,
    EnterPosterPageButton,
    LandingPageContent,
    EnterPosterPageContent,
    GameplayTipsContent,
    StartGameButton,
    PopUpLeftButton,
    PopUpRightButton,
    PopUpCloseButton,
    PreviousPosterButton,
    NextPosterButton,
    PostBeforeContent,
    PostAfterContent,
    PostAfterTipsContent,
    EnterVoucherPageButton,
    EnterShopPageButton,
    EnterNextPosterPageButton,
    PosterPageA,
    PosterPageB,
    PosterPageC,
    PosterPageD,
    PosterPageE,
    PosterPageF,
    PosterPageSaveA,
    PosterPageSaveB,
    PosterPageSaveC,
    PosterPageSaveD,
    PosterPageSaveE,
    PosterPageSaveF,
    GamePageBG,
    GamePageMG,
    GamePageFG,
    // GamePageMGBlur, GamePageFGBlur,
    GamePageMGFull,
    GamePageFGFull,
    GamePageBGCloud,
    GamePageMGFloatA,
    GamePageMGFloatB,
    GamePageMGFloatC,
    GamePageMGFloatD,
    GamePageMGFloatE,
    GamePageMGFloatF,
    GamePageMGFloatG,
    GamePageMGFloatH,
    GamePageMGFloatI,
    GamePageMGFloatJ,
    GamePageMGFloatK,
    GamePageMGFloatL,
    Product111,
    Product112,
    Product121,
    Product122,
    Product211,
    Product212,
    Product213,
    Product214,
    Product221,
    Product222,
    Product223,
    Product311,
    Product312,
    Product313,
    Product314,
    Product321,
    Product411,
    Product412,
    Product413,
    Product414,
    Product421,
    Product422,
    Product423,
    Product424,
    Product511,
    Product512,
    Product521,
    Product522,
    Product523,
    Product524,
    Product531,
    Product532,
    Product541,
    Product551,
    Product561,
    Product562,
    Product571,
    Product572,
    Product573,
    Product574,
    Product581,
    Product582,
    Product591,
    Product592
];

class HomePage extends React.Component
{
    constructor(props) {
        super(props);

        this.state = {
            loaded: false,
            loadingRequired: true,
            landingRequired: false,
            gameRequired: false,
            posterRequired: false,
            loadedResources: 0,
            musicState: false,
            bgmReady: true,
            nonHorizontal: false,
            gamePageLoaded: false,
            posterPageLoaded: false,
            showMusicIcon: false,
            performanceMode: false,
            shop: 0,
        };

        this.log = [];
        this.loadedResources = 0;
        this.loadedTime = 0;
        this.gameEnterTime = 0;
        this.posterEnterTime = 0;
        this.shop = 0;

        this.performanceLog = [];

        this.resources = {};

        this.logCount = 0;

        this.startDownloadTime = 0;

        this.backgroundMusic = null;

        this.loadedAudio = this
            .loadedAudio
            .bind(this);

        this.loadedImage = this
            .loadedImage
            .bind(this);

        this.updateMusicState = this
            .updateMusicState
            .bind(this);

        this.enterGamePage = this
            .enterGamePage
            .bind(this);

        this.addToLog = this
            .addToLog
            .bind(this);

        this.startDataLoading = this
            .startDataLoading
            .bind(this);

        this.gamePageLoadedCallback = this
            .gamePageLoadedCallback
            .bind(this);

        this.getImage = this
            .getImage
            .bind(this);

        this.controlMusicIcon = this
            .controlMusicIcon
            .bind(this);

        this.enterPosterPage = this
            .enterPosterPage
            .bind(this);

        this.prepareToLoad = this
            .prepareToLoad
            .bind(this);
    }

    handleResize = e => {
        this.addToLog([
            "Resizing",
            window.innerWidth,
            window.innerHeight,
            window.screen.availWidth,
            window.screen.availHeight,
            document.documentElement.clientWidth,
            document.documentElement.clientHeight
        ]);

        if ((document.documentElement.clientHeight > document.documentElement.clientWidth) !== this.state.nonHorizontal) {
            this.setState({
                currentWidth: document.documentElement.clientWidth,
                currentHeight: document.documentElement.clientHeight,
                nonHorizontal: document.documentElement.clientHeight > document.documentElement.clientWidth,
                shop: this.shop
            });
        }
    };

    componentDidMount()
    {
        this.backgroundMusic = new Audio();

        this.backgroundMusic.volume = 0.0625;
        this.backgroundMusic.src = BGM;
        this.backgroundMusic.loop = true;

        window.addEventListener("resize", this.handleResize);

        this.checkOrientationTimer = setInterval(() => {
            this.handleResize();
            if (this.state.gameRequired) {
                clearInterval(this.checkOrientationTimer);
            }
        }, 1000);

        let params = queryString.parse(window.location.search);


        if (params.v !== undefined && params.v !== null) {
            if (params.v === "ole") {
                this.shop = 0;
            }
            if (params.v === "blt") {
                this.shop = 1;
            }
        }

        for (var i = 0; i < 7; i++) {
            this
                .performanceLog
                .push(this.measurePerformance());
        }

        this.setState({
            currentWidth: document.documentElement.clientWidth,
            currentHeight: document.documentElement.clientHeight,
            nonHorizontal: document.documentElement.clientHeight > document.documentElement.clientWidth,
            performanceMode: getMedian(this.performanceLog) > 0.2
        });
    }

    componentWillUnmount()
    {
        if (this.backgroundMusic !== null) {
            this
                .backgroundMusic
                .pause();
        }
    }

    measurePerformance()
    {
        var d = new Date();
        var amount = 150000000;
        for (var i = amount; i > 0; i--) {}
        var newd = new Date();
        var accnewd = Number(String(newd.getSeconds()) + "." + String(newd.getMilliseconds()));
        var accd = Number(String(d.getSeconds()) + "." + String(d.getMilliseconds()));
        return accnewd - accd;
    }

    startDataLoading()
    {
        const loadResource = (resource, index) => {
            return new Promise((resolve, reject) => {
                const loadImage = new Image();
                loadImage.src = resource;

                loadImage.onload = () => {
                    resolve(resource);
                    this.loadedImage(loadImage, index);
                }

                loadImage.onerror = err => {
                    reject(err);
                    this.addToLog(debugPrint(`Failed img -> ${resource}`));
                }
            });
        }

        window.sendTracking("page", "pageview", "loading");

        this.startDownloadTime = new Date().valueOf();

        Promise.all(resourceToLoad.map((resource, index) => loadResource(resource, index))).catch(err => console.log("Failed to load images", err))
    }

    prepareToLoad()
    {
        this.handleResize();
        this.prepareToLoadTimer = setInterval(() => {
            if (!this.state.nonHorizontal) {
                this.startDataLoading();
                clearInterval(this.prepareToLoadTimer);
            } else {}
        }, 250);
    }

    addToLog(log)
    {
        this.logCount += 1;
        if (this.log.length > 10) {
            this
                .log
                .shift();
        }
        this
            .log
            .push({log: log, id: this.logCount});
        this.setState({});
    }

    loadedAudio(audio, path = "")
    {
        // this.addToLog(debugPrint(`Loaded audio -> ${path}`));
        this.resources[path] = audio;
        this.backgroundMusic = audio;
        this.loadedResources += 1;
        this.setState({loadedResources: this.loadedResources, bgmReady: true});
        this.checkLoading();
    }

    loadedImage(image, path)
    {
        // this.addToLog(debugPrint(`Loaded img - ${path}`));
        this.resources[path] = getBase64Image(image);
        this.loadedResources += 1;
        this.setState({loadedResources: this.loadedResources});
        this.checkLoading();
    }

    gamePageLoadedCallback()
    {
        this.gamePageLoaded = true;
    }

    checkLoading()
    {
        if (this.loadedResources === resourceToLoad.length) {
            window.sendTracking("page", "pageview", "landing");
            setTimeout(() => {
                this.loadedTime = new Date().valueOf();
                this.setState({loaded: true, landingRequired: true});
                this.killLoading();
            }, 3000);
        }
    }

    killLoading()
    {
        this.killLoadingTimer = setInterval(() => {
            if (this.state.loaded && (new Date().valueOf() - this.loadedTime > 1500)) {
                this.setState({loadingRequired: false});
                clearInterval(this.killLoadingTimer);
            }
        }, 1000);
    }

    killLanding()
    {
        this.killLandingTimer = setInterval(() => {
            if (this.state.loaded && (new Date().valueOf() - this.gameEnterTime > 1500)) {
                this.setState({landingRequired: false});
                clearInterval(this.killLandingTimer);
            }
        }, 1000);
    }

    killGame()
    {
        this.killGameTimer = setInterval(() => {
            if (this.state.loaded && (new Date().valueOf() - this.posterEnterTime > 1500)) {
                this.setState({gameRequired: false});
                clearInterval(this.killGameTimer);
            }
        }, 250);
    }

    updateMusicState()
    {
        if (this.state.musicState) {
            this
                .backgroundMusic
                .pause();
        } else {
            this
                .backgroundMusic
                .play();
        }
        this.setState({
            musicState: !this.state.musicState
        })
    }

    enterGamePage()
    {
        window.sendTracking("click", "btn", "landing/start");
        this
            .backgroundMusic
            .play();
        this.gameEnterTime = new Date().valueOf();
        this.setState({gameRequired: true, musicState: true, showMusicIcon: true})
        this.killLanding();
    }

    enterPosterPage()
    {
        window.sendTracking("page", "pageview", "poster");
        this.posterEnterTime = new Date().valueOf();
        this.setState({posterRequired: true})
        this.killGame();
    }

    getImage(key)
    {
        return this.resources[resourceToLoad.indexOf(key)];
    }

    controlMusicIcon(enable)
    {
        this.setState({showMusicIcon: enable});
    }

    render()
    {
        return (
            <div id="main" style={{
                overflow: "hidden"
            }}>
                <div
                    style={{
                    zIndex: this.state.nonHorizontal
                        ? 55
                        : -55,
                    opacity: this.state.nonHorizontal
                        ? 1
                        : 0,
                    width: "100%",
                    height: "100vh",
                    position: "absolute",
                    display: "flex",
                    justifyContent: "center",
                    backgroundColor: UIColors.backgroundNew
                }}>{this.state.nonHorizontal
                        ? <img
                                src={PortraitModeAlert}
                                alt="Portrait mode alert"
                                style={{
                                maxWidth: "80%",
                                maxHeight: "90%",
                                display: "inline-block",
                                justifySelf: "center",
                                alignSelf: "center"
                            }}/>
                        : null}{this.state.nonHorizontal
                        ? <img
                                src={Title}
                                alt="Title"
                                style={{
                                position: "absolute",
                                right: "5vh",
                                top: 0,
                                maxHeight: "6.5vh",
                                display: "inline-block"
                            }}/>
                        : null}</div>
                <div>{this.state.loadingRequired
                        ? <div
                                className={this.state.loaded
                                ? "fade-out"
                                : "fade-in"}
                                style={{
                                width: "100%",
                                height: "100vh",
                                position: "absolute",
                                display: "inherit"
                            }}><LoadingPage
                                total={resourceToLoad.length}
                                loaded={this.loadedResources}
                                fullyLoadedFunc={this.prepareToLoad}/></div>
                        : null} {this.state.landingRequired
                        ? <div
                                className={this.state.loaded
                                ? "fade-in"
                                : "fade-out"}
                                style={{
                                zIndex: 10,
                                width: "100%",
                                height: "100vh",
                                position: "absolute",
                                display: this.state.loaded
                                    ? "inherit"
                                    : "none"
                            }}><LandingPage
                                titleImage={this.getImage(Title)}
                                backgroundImage={this.getImage(LandingPageBG)}
                                contentImage={this.getImage(LandingPageContent)}
                                buttonImage={this.getImage(LandingPageButton)}
                                buttonFunc={this.enterGamePage}
                                startGameFunc={this.updateMusicState}/></div>
                        : null}
                    {this.state.gameRequired
                        ? <div
                                className={this.state.gameRequired
                                ? "fade-in"
                                : "fade-out"}
                                style={{
                                zIndex: this.state.gameRequired
                                    ? 20
                                    : -20,
                                width: "100%",
                                height: "100vh",
                                position: "absolute",
                                display: this.state.loaded
                                    ? "inherit"
                                    : "none"
                            }}><GamePage
                                fullyLoadedFunc={this.gamePageLoadedCallback}
                                performanceMode={this.state.performanceMode}
                                speed={10}
                                imageWidth={12000}
                                logFunc={this.addToLog}
                                controlMusicIconFunc={this.controlMusicIcon}
                                enterPosterPageFunc={this.enterPosterPage}
                                locationDescriptionImagesB64={[
                                this.getImage(GamePageBGLocationDescriptionA),
                                this.getImage(GamePageBGLocationDescriptionB),
                                this.getImage(GamePageBGLocationDescriptionC),
                                this.getImage(GamePageBGLocationDescriptionD),
                                this.getImage(GamePageBGLocationDescriptionE)
                            ]}
                                locationDescriptionImages={[GamePageBGLocationDescriptionA, GamePageBGLocationDescriptionB, GamePageBGLocationDescriptionC, GamePageBGLocationDescriptionD, GamePageBGLocationDescriptionE]}
                                locationMarker={[5, 20, 32.5, 48.8, 61]}
                                popUpMarker={[
                                {
                                    x: 8.5,
                                    y: 33.5,
                                    z: 0,
                                    images: [
                                        this.getImage(Product111),
                                        this.getImage(Product112),
                                        this.getImage(Product121),
                                        this.getImage(Product122)
                                    ]
                                }, {
                                    x: 22.25,
                                    y: 33.5,
                                    z: 0,
                                    images: [
                                        this.getImage(Product211),
                                        this.getImage(Product212),
                                        this.getImage(Product213),
                                        this.getImage(Product214),
                                        this.getImage(Product221),
                                        this.getImage(Product222),
                                        this.getImage(Product223)
                                    ]
                                }, {
                                    x: 40.25,
                                    y: 18.5,
                                    z: 0,
                                    images: [
                                        this.getImage(Product311),
                                        this.getImage(Product312),
                                        this.getImage(Product313),
                                        this.getImage(Product314),
                                        this.getImage(Product321)
                                    ]
                                }, {
                                    x: 53,
                                    y: 37,
                                    z: 0,
                                    images: [
                                        this.getImage(Product411),
                                        this.getImage(Product412),
                                        this.getImage(Product413),
                                        this.getImage(Product414),
                                        this.getImage(Product421),
                                        this.getImage(Product422),
                                        this.getImage(Product423),
                                        this.getImage(Product424)
                                    ]
                                }, {
                                    x: 76.2,
                                    y: 31,
                                    z: 0,
                                    images: [
                                        this.getImage(Product521),
                                        this.getImage(Product522),
                                        this.getImage(Product523),
                                        this.getImage(Product524),
                                        this.getImage(Product531),
                                        this.getImage(Product532),
                                        this.getImage(Product541),
                                        this.getImage(Product551)
                                    ]
                                }, {
                                    x: 85.65,
                                    y: 71,
                                    z: 0,
                                    images: [
                                        this.getImage(Product511),
                                        this.getImage(Product512),
                                        this.getImage(Product561),
                                        this.getImage(Product562),
                                        this.getImage(Product571),
                                        this.getImage(Product572),
                                        this.getImage(Product573),
                                        this.getImage(Product574),
                                        this.getImage(Product581),
                                        this.getImage(Product582),
                                        this.getImage(Product591),
                                        this.getImage(Product592)
                                    ]
                                }
                            ]}
                                startGameButton={this.getImage(StartGameButton)}
                                gameplayTipsContent={this.getImage(GameplayTipsContent)}
                                backwardButtonReleasedImage={GamePageBackwardButtonReleased}
                                backwardButtonPressedImage={GamePageBackwardButtonPressed}
                                forwardButtonReleasedImage={GamePageForwardButtonReleased}
                                forwardButtonPressedImage={GamePageForwardButtonPressed}
                                popUpLeftButtonImage={this.getImage(PopUpLeftButton)}
                                popUpRightButtonImage={this.getImage(PopUpRightButton)}
                                popUpCloseButtonImage={this.getImage(PopUpCloseButton)}
                                lightBulbButtonImage={this.getImage(GamePageLightBulbButton)}
                                backgroundFloatImageLists={[
                                {
                                    x: 1.8,
                                    y: 0,
                                    image: this.getImage(GamePageMGFloatA)
                                }, {
                                    x: 2.5,
                                    y: 0,
                                    image: this.getImage(GamePageMGFloatB)
                                }, {
                                    x: 9.5,
                                    y: 0,
                                    image: this.getImage(GamePageMGFloatC)
                                }, {
                                    x: 14,
                                    y: 0,
                                    image: this.getImage(GamePageMGFloatD)
                                }, {
                                    x: 14.8,
                                    y: 0,
                                    image: this.getImage(GamePageMGFloatE)
                                }, {
                                    x: 22,
                                    y: 0,
                                    image: this.getImage(GamePageMGFloatF)
                                }, {
                                    x: 28.5,
                                    y: 0,
                                    image: this.getImage(GamePageMGFloatG)
                                }, {
                                    x: 29.5,
                                    y: 0,
                                    image: this.getImage(GamePageMGFloatH)
                                }, {
                                    x: 34.5,
                                    y: 0,
                                    image: this.getImage(GamePageMGFloatI)
                                }, {
                                    x: 50.8,
                                    y: 0,
                                    image: this.getImage(GamePageMGFloatJ)
                                }, {
                                    x: 51.6,
                                    y: 0,
                                    image: this.getImage(GamePageMGFloatK)
                                }, {
                                    x: 54,
                                    y: 0,
                                    image: this.getImage(GamePageMGFloatL)
                                }
                            ]}
                                contentImage={this.getImage(EnterPosterPageContent)}
                                buttonImage={this.getImage(EnterPosterPageButton)}
                                backgroundImage={GamePageBG}
                                backgroundCloudImage={GamePageBGCloud}
                                midgroundImage={GamePageMG}
                                foregroundImage={GamePageFG}
                                midgroundFullImage={GamePageMGFull}
                                foregroundFullImage={GamePageFGFull}
                                darkBG={this.getImage(DarkBG)}
                                animation={BikeGirl}
                                animationRest={this.getImage(BikeGirlRest)}/></div>
                        : null}
                </div>
                {this.state.posterRequired
                    ? <div
                            className={this.state.posterRequired
                            ? "fade-in"
                            : "fade-out"}
                            style={{
                            zIndex: this.state.posterRequired
                                ? 30
                                : -30,
                            width: "100%",
                            height: "100vh",
                            position: "absolute",
                            WebKitAnimationDuration: "0.5s",
                            animationDuration: "0.5s"
                        }}><PosterPage
                            titleImage={this.getImage(Title)}
                            shop={this.state.shop}
                            clickEnabled={!this.state.gameRequired}
                            contentPreImage={this.getImage(PostBeforeContent)}
                            contentPostImage={this.getImage(PostAfterContent)}
                            tipsImage={this.getImage(PostAfterTipsContent)}
                            nextPageButtonImage={this.getImage(EnterNextPosterPageButton)}
                            enterVoucherButtonImage={this.getImage(EnterVoucherPageButton)}
                            enterShopButtonImage={this.getImage(EnterShopPageButton)}
                            previousPosterButtonImage={this.getImage(PreviousPosterButton)}
                            nextPosterButtonImage={this.getImage(NextPosterButton)}
                            posterCombo={[
                            {
                                pre: this.getImage(PosterPageA),
                                post: (PosterPageSaveA)
                            }, {
                                pre: this.getImage(PosterPageB),
                                post: (PosterPageSaveB)
                            }, {
                                pre: this.getImage(PosterPageC),
                                post: (PosterPageSaveC)
                            }, {
                                pre: this.getImage(PosterPageD),
                                post: (PosterPageSaveD)
                            }, {
                                pre: this.getImage(PosterPageE),
                                post: (PosterPageSaveE)
                            }, {
                                pre: this.getImage(PosterPageF),
                                post: (PosterPageSaveF)
                            }
                        ]}
                            postBeforeImage/></div>
                    : null}
                {this.state.bgmReady && (this.state.gameRequired || this.state.posterRequired)
                    ? <div
                            className={this.state.showMusicIcon
                            ? "fade-in"
                            : "fade-out"}
                            style={{
                            zIndex: 40,
                            position: "absolute",
                            top: 16,
                            left: 40
                        }}>
                            <MusicButton
                                imageSize={this.state.nonHorizontal
                                ? "7.5vw"
                                : "7.5vh"}
                                musicState={this.state.musicState}
                                musicToggleFunc={this.updateMusicState}
                                musicToggleOnImage={MusicToggleOnButton}
                                musicToggleOffImage={MusicToggleOffButton}/></div>
                    : null}
            </div>
        );
    }
}

export default HomePage;